import { style, styleVariants } from '@vanilla-extract/css';

export const commentList = style({
  listStylePosition: 'inside',
  whiteSpace: 'normal',
});

export const commentListType = styleVariants({
  decimal: {
    listStyleType: 'decimal',
  },
  disc: {
    listStyleType: 'disc',
  },
  none: {
    listStyleType: 'none',
  },
});
